export class RequestPasswordResetRequest {

    constructor(email: string) {
        this.email = email;
    }

    email: string;
}